
import { Component, Prop, State, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import Link from '@/components/ui/toc/links/Link';
import { PageContentInfo, PageTreeData } from '@/types/initialData';

@Component({
  name: 'SiteMapRaw'
})
export default class SiteMapRaw extends Vue {
  @Prop({
    type: Object as PropType<Link>,
    required: true
  })
  links: Link;

  locationHost: string = window.location.host;
  baseUrl: string = `https://${this.locationHost}`;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.pagetreedata)
  pageTreeData: PageTreeData;

  get pageContentInfo(): PageContentInfo {
    const pageData: PageContentInfo =
      this.pageTreeData && this.links.uid in this.pageTreeData
        ? this.pageTreeData[this.links.uid]
        : null;
    if (pageData !== null) {
      return {
        pbookPage: pageData?.pbookPage ?? 0,
        chapter: pageData?.chapter ?? 0,
        characters: pageData?.characters ?? 0,
        images: pageData?.images ?? 0,
        interactiveElements: pageData?.interactiveElements ?? 0,
        math: pageData?.math ?? 0,
        ogStandardPage: pageData?.ogStandardPage ?? 0,
        originalMaterial: pageData?.originalMaterial ?? 0,
        quizzes: pageData?.quizzes ?? 0,
        soundFiles: pageData?.soundFiles ?? 0,
        standardPage: pageData?.standardPage ?? 0,
        videos: pageData?.videos ?? 0,
        words: pageData?.words ?? 0,
        iPages: pageData?.iPages ?? 0,
        chapterInfo: pageData?.chapterInfo
      };
    }
    return null;
  }

  get realLink() {
    return `${this.baseUrl}/?id=${this.links.uid as string}`;
  }

  get hasChildren() {
    return this.links.children && this.links.children.length > 0;
  }
}
